import React from 'react';
import { Box, VStack, Image, Link, Icon, Text } from '@chakra-ui/react';
import { RiArrowRightUpLine } from 'react-icons/ri';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionText = motion(Text);

const ProjectCard = ({ title, description, imageUrl, imageAlt, link }) => {
  return (
    <Box w="100%" mb={{ base: 10, md: 0 }}>
      <VStack align="flex-start" spacing={4}>
        <MotionText
          as="h3" 
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {title}
        </MotionText>
        
        <MotionText
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
        >
          {description}
        </MotionText>
        
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Link 
            href={link} 
            display="flex" 
            alignItems="center" 
            _hover={{ color: "cyan.400" }}
            role="group"
          >
            View Live <Icon as={RiArrowRightUpLine} ml={2} fontSize="20px" transform="rotate(-45deg)" transition="transform 0.3s ease" _groupHover={{ transform: "rotate(-45deg) translateX(3px) translateY(-3px)" }} />
          </Link>
        </MotionBox>
        
        <MotionBox
          w="100%"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <Image 
            src={imageUrl} 
            alt={imageAlt} 
            borderRadius="md"
            w="100%"
            maxH={{ base: "250px", md: "400px" }}
            objectFit="cover"
          />
        </MotionBox>
      </VStack>
    </Box>
  );
};

export default ProjectCard;